import { render, staticRenderFns } from "./RentApartmentView.vue?vue&type=template&id=2404195b&"
import script from "./RentApartmentView.vue?vue&type=script&lang=js&"
export * from "./RentApartmentView.vue?vue&type=script&lang=js&"
import style0 from "./RentApartmentView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports